import {
  AdditionalResourcesSection,
  AdditionalResourcesContainer,
  SectionTitle,
  SectionTitleHighlight,
  AssetsGrid,
  ResourceDescription,
  ResourceItem,
} from './styles';
import { RESOURCES } from './constants';

const AdditionalResources = () => (
  <AdditionalResourcesSection>
    <AdditionalResourcesContainer>
      <SectionTitle>
        Additional&nbsp;
        <SectionTitleHighlight>Resources</SectionTitleHighlight>
      </SectionTitle>

      <AssetsGrid>
        {RESOURCES.map((resource) => (
          <ResourceItem
            key={resource.description}
            href={resource.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <resource.icon />
            <ResourceDescription>{resource.description}</ResourceDescription>
          </ResourceItem>
        ))}
      </AssetsGrid>
    </AdditionalResourcesContainer>
  </AdditionalResourcesSection>
);

export default AdditionalResources;
